export enum TabelaComissaoSobre {
    SobreProdutos = 1,
    SobreTotalFaturado = 2,
}

export enum TabelaComissaoTipo {
    GerarComissaoAoRegistrarCobranca = 1,
    GerarComissaoIntegralNoFaturamento = 2,
}
